import React from "react";
import { Container, Typography, Box, useMediaQuery } from "@mui/material";
import Slider from "react-slick";
import HomeImage from "../../images/header-ai.png";
import MainImage from "../../images/main_ai_last.png";
import ProImage from "../../images/product.png";
import ServiceImage from "../../components/Card/s3.png";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";

// Görseller dizisi
const images = [
  { src: HomeImage, alt: "mastersoft bilgisi" },
  { src: MainImage, alt: "makine öğrenmesi ve yapay zeka projeleri" },
  { src: ProImage, alt: "hizmetler bilgisi" },
  { src: ServiceImage, alt: "servis görseli" },
];

// Özel sağ ok
const CustomNextArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block", right: 10, zIndex: 2 }}
      onClick={onClick}
    />
  );
};

// Özel sol ok
const CustomPrevArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block", left: 10, zIndex: 2 }}
      onClick={onClick}
    />
  );
};

function Home() {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // Slider ayarları
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    nextArrow: <CustomNextArrow />,
    prevArrow: <CustomPrevArrow />,
  };

  return (
    <Container maxWidth="lg">
      {/* Başlık */}
      <Box
        bgcolor="#76959c"
        p={2}
        borderRadius={5}
        my={4}
        textAlign="center"
      >
        <Typography variant="h4" color="white">
          {t("home_title.tit")}
        </Typography>
      </Box>

      {/* Slider */}
      <Box
        display="flex"
        justifyContent="center"
        px={{ xs: 1, sm: 2, md: 0 }}
        mb={4}
      >
        <Slider
          {...sliderSettings}
          style={{
            width: "100%",
            maxWidth: isMobile ? "100%" : "700px",
          }}
        >
          {images.map((image, index) => (
            <Box key={index} textAlign="center">
              <img
                src={image.src}
                alt={image.alt}
                style={{
                  width: "100%",
                  height: isMobile ? "200px" : "350px",
                  objectFit: "cover",
                  borderRadius: 8,
                }}
              />
            </Box>
          ))}
        </Slider>
      </Box>

      {/* Açıklama */}
      <Box textAlign="center" mb={4}>
        <Typography variant="h5" gutterBottom color="#76959c">
          {t("home_title.subtit")}
        </Typography>
        <Typography variant="body1" sx={{ fontSize: "1.2rem" }}>
          {t("home_title.desc")}
        </Typography>
      </Box>
    </Container>
  );
}

export default Home;
